import { Button, Heading, Menu } from '@components'
import { A, useLocation } from '@solidjs/router'
import { For, Index, createEffect, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { useSingle } from '../state'
import { Box, HStack } from 'styled-system/jsx'

export const Navigation = () => {
	const [path, setPath] = createSignal<string | undefined>()
	const { isArchived } = useService(useSingle)()

	const location = useLocation()

	const options = () => {
		return [
			{ id: '/', label: 'Overview', disabled: false },
			{ id: 'chat', label: 'Chat', disabled: isArchived() },
			{ id: 'chart', label: 'Chart' },
			// { id: 'journal', label: 'Journal', disabled: false },
			// { id: 'analysis', label: 'Analysis', disabled: false },
		]
	}

	createEffect(() => {
		const getRelativePath = () => {
			const parts = location.pathname.split('/').slice(3) // Adjust based on your route depth
			return parts.join('/') || '/' // Ensure it defaults to "/"
		}

		setPath(getRelativePath())
	})

	return (
		<Box
			display={{
				base: 'none',
				mdDown: 'block',
			}}
		>
			<Menu.Root>
				<Menu.Trigger>
					<Button
						variant="outline"
						size="xs"
					>
						<Heading textTransform="capitalize">
							{path() === '/' ? 'overview' : path()}
						</Heading>
					</Button>
				</Menu.Trigger>
				{/* <Portal> */}
				<Menu.Positioner>
					<Menu.Content>
						<Menu.ItemGroup>
							<Index each={options()}>
								{(option) => (
									<A
										href={option().id === '/' ? '' : option().id}
										class={css({
											color: option().disabled ? 'gray.7' : '',
										})}
									>
										<Menu.Item value={option().id}>
											<HStack gap={2}>
												<Heading textTransform="capitalize">{option().label}</Heading>
											</HStack>
										</Menu.Item>
									</A>
								)}
							</Index>
						</Menu.ItemGroup>
					</Menu.Content>
				</Menu.Positioner>
				{/* </Portal> */}
			</Menu.Root>
		</Box>
	)
}
